
<div class="label-value-wrapper" :size="size">
	<div class="label">
		{{ label }}
	</div>
	<div class="value">
		{{ value }}
	</div>
</div>
